import React, { CSSProperties } from "react";

import ChekImages from "static/images/checked.png";
import styles from "../views.module.scss";

type TextBlockProps = {
	label?: string;
	value?: string;
	dataAutotest?: string;
	iconCheck?: boolean;
	noMarging?: boolean;
	style?: CSSProperties;
	isNoColon?: boolean;
};

const TextBlock = ({
	label,
	value,
	dataAutotest,
	iconCheck = false,
	noMarging = false,
	style,
	isNoColon = false,
}: TextBlockProps) => {
	return (
		<div className={`${styles.subTabs} ${noMarging && styles.noMarging}`}>
			<div className="d-flex" data-autotest={dataAutotest} style={style}>
				{label && (
					<p className={styles.dataTitle}>
						{label}
						{isNoColon ? "" : ":"}
					</p>
				)}
				{iconCheck && (
					<p className="mr-3">
						<img src={ChekImages} alt="" />
					</p>
				)}
				<p className={styles.dataResuls}>{value}</p>
			</div>
		</div>
	);
};

export default TextBlock;
